import { render, staticRenderFns } from "./StepRestricoes.vue?vue&type=template&id=28528082"
import script from "./StepRestricoes.vue?vue&type=script&lang=js"
export * from "./StepRestricoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports